import React from 'react';
import { getLayoutKeyForMetaObjects } from '../../utils/getLayoutKeyForMetaObjects';
import { ppData } from '../../configs/ppData.config';
import { ShopifyRichText } from '../../../../Components/react/ShopifyRichText';
import { InfoAccordion } from './InfoAccordion';
import { InfoList } from './InfoList';
import { InfoImages } from './InfoImages';
import { replaceHyphen } from '../../utils/replaceHyphen';
import { InfoDescription } from './InfoDescription';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_LAYOUT } from '../../constants/searchParamKeys';
export const Info = () => {
    const [searchParams] = useSearchParams();
    const layout = searchParams.get(SEARCH_PARAM_KEY_LAYOUT);
    if (layout === null)
        return null;
    const metaKey = getLayoutKeyForMetaObjects(layout);
    const typeName = replaceHyphen(metaKey.toUpperCase());
    if (ppData.info[metaKey] === undefined)
        return null;
    const { careTips, careTipsAdditional, features, instructions, benefits } = ppData.info[metaKey];
    return (React.createElement("div", { className: "mt:28 mt:40:xl-up" },
        React.createElement(InfoAccordion, { title: "PRODUCT DETAILS" }, ppData.staticDescription !== undefined
            ? React.createElement("p", null, ppData.staticDescription)
            : React.createElement(InfoDescription, null)),
        ((features.items !== null && features.items.length > 0) || features.images.length > 0) &&
            React.createElement(InfoAccordion, { title: `${typeName} FEATURES` },
                features.items !== null && features.items.length > 0 &&
                    React.createElement(InfoList, { items: features.items }),
                features.images.length > 0 &&
                    React.createElement(InfoImages, { items: features.images })),
        benefits !== null && benefits.length > 0 &&
            React.createElement(InfoAccordion, { title: `${typeName} BENEFITS` },
                React.createElement(InfoList, { items: benefits })),
        ((instructions.items !== null && instructions.items.length > 0) || instructions.images.length > 0) &&
            React.createElement(InfoAccordion, { title: "HANGING INSTRUCTIONS" },
                instructions.items !== null && instructions.items.length > 0 &&
                    React.createElement(InfoList, { items: instructions.items }),
                instructions.images.length > 0 &&
                    React.createElement(InfoImages, { items: instructions.images })),
        careTips !== null && careTips.length > 0 &&
            React.createElement(InfoAccordion, { title: "CARE TIPS" },
                React.createElement(InfoList, { items: careTips }),
                careTipsAdditional !== null &&
                    React.createElement(ShopifyRichText, { items: careTipsAdditional.children }))));
};
